import {SnackbarParams} from "../types/snackbar-params.types";

export const defaultSnackbarParams: SnackbarParams = {
  type: 'success',
  message: '',
  config: {
    duration: 5000,
    verticalPosition: 'bottom',
    horizontalPosition: 'center'
  },
  buttonText: 'Закрыть'
};


